const ROOT_SELECTOR = '[data-menu-drilldown]';
const INSTANT_CLASS = 'menu-drawer--instant-submenu';

document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
  if (!(root instanceof HTMLElement)) return;

  const drawer = root.closest('[data-drawer-id]');
  const drawerId = drawer?.getAttribute('data-drawer-id');
  const tabButtons = root.querySelectorAll('[data-menu-top-tab]');
  const panels = root.querySelectorAll('[data-menu-panel]');

  function defaultTabIndex() {
    const raw = root.getAttribute('data-menu-default-tab');
    let n = raw == null || raw === '' ? 0 : Number.parseInt(raw, 10);
    if (!Number.isFinite(n) || n < 0) n = 0;
    const max = panels.length - 1;
    if (max >= 0 && n > max) n = 0;
    return String(n);
  }

  const openStack = [];

  /** Snap submenu transforms without CSS transition (base.css disables transition under this class). */
  function withoutSubmenuTransition(run) {
    root.classList.add(INSTANT_CLASS);
    run();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        root.classList.remove(INSTANT_CLASS);
      });
    });
  }

  function hideSubmenu(submenu) {
    submenu.classList.add('translate-x-full');
  }

  function showSubmenu(submenu) {
    submenu.classList.remove('translate-x-full');
  }

  function closeAllSubmenus() {
    root.querySelectorAll('[data-menu-panel] ul').forEach((el) => {
      if (!(el instanceof HTMLUListElement)) return;
      if (el.matches('[data-menu-panel] > ul')) return;
      el.classList.add('translate-x-full');
    });
    openStack.length = 0;
  }

  function expandToCurrentPage() {
    closeAllSubmenus();

    let visiblePanel = null;
    for (const panel of panels) {
      if (!(panel instanceof HTMLElement)) continue;
      if (panel.hasAttribute('hidden')) continue;
      if (panel.classList.contains('hidden')) continue;
      visiblePanel = panel;
      break;
    }
    if (!visiblePanel) return;

    const current = visiblePanel.querySelector('a[aria-current="page"]');
    if (!(current instanceof HTMLAnchorElement)) return;

    const chain = [];
    let li = current.closest('li');
    let parentUl = li?.parentElement;
    while (parentUl instanceof HTMLUListElement && !parentUl.matches('[data-menu-panel] > ul')) {
      chain.push(parentUl);
      const ancestorLi = parentUl.parentElement;
      parentUl = ancestorLi instanceof HTMLLIElement ? ancestorLi.parentElement : null;
    }

    chain.reverse();
    for (const u of chain) {
      if (u instanceof HTMLUListElement) {
        showSubmenu(u);
        openStack.push(u);
      }
    }
  }

  function drawerOpen() {
    return drawer instanceof HTMLElement && drawer.classList.contains('is-open');
  }

  function activateMenuTab(index) {
    if (panels.length === 0) return;
    const idx = String(index);
    closeAllSubmenus();
    tabButtons.forEach((btn) => {
      const isMatch = btn.getAttribute('data-menu-tab-index') === idx;
      btn.setAttribute('aria-selected', isMatch ? 'true' : 'false');
    });
    panels.forEach((panel) => {
      if (!(panel instanceof HTMLElement)) return;
      const isMatch = panel.getAttribute('data-menu-tab-index') === idx;
      panel.toggleAttribute('hidden', !isMatch);
      panel.classList.toggle('hidden', !isMatch);
    });

    if (drawerOpen()) {
      expandToCurrentPage();
    } else {
      withoutSubmenuTransition(expandToCurrentPage);
    }
  }

  root.addEventListener('click', (event) => {
    const tab = event.target instanceof Element ? event.target.closest('[data-menu-top-tab]') : null;
    if (tab instanceof HTMLButtonElement) {
      const index = tab.getAttribute('data-menu-tab-index');
      if (index != null) {
        event.preventDefault();
        activateMenuTab(index);
      }
      return;
    }

    const target = event.target;
    if (!(target instanceof Element)) return;

    const back = target.closest('[data-menu-drilldown-back]');
    if (back instanceof HTMLButtonElement) {
      event.preventDefault();
      const last = openStack.pop();
      if (last) hideSubmenu(last);
      return;
    }

    const trigger = target.closest('button');
    if (!(trigger instanceof HTMLButtonElement)) return;

    const li = trigger.closest('li');
    if (!(li instanceof HTMLLIElement)) return;

    const submenu = li.querySelector(':scope > ul');
    if (!(submenu instanceof HTMLUListElement)) return;

    event.preventDefault();

    const parentSubmenu = li.closest('ul');
    while (openStack.length > 0) {
      const last = openStack[openStack.length - 1];
      const lastParentLi = last.closest('li');
      const lastParentSubmenu = lastParentLi?.closest('ul') || null;

      if (lastParentSubmenu === parentSubmenu) {
        hideSubmenu(last);
        openStack.pop();
      } else {
        break;
      }
    }

    showSubmenu(submenu);
    openStack.push(submenu);
  });

  if (drawerId) {
    document.addEventListener('drawer:opened', (event) => {
      if (event.detail?.id !== drawerId) return;
      withoutSubmenuTransition(expandToCurrentPage);
    });

    document.addEventListener('drawer:closed', (event) => {
      if (event.detail?.id !== drawerId) return;
      if (panels.length > 0) {
        activateMenuTab(defaultTabIndex());
      } else {
        closeAllSubmenus();
      }
    });
  }

  if (panels.length > 0) {
    activateMenuTab(defaultTabIndex());
  } else {
    closeAllSubmenus();
  }
});
